const C = {
  name: "Milan",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="currentColor"/>
<path d="M13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11Z" fill="currentColor"/>
<path d="M19 17C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16C18 16.5523 18.4477 17 19 17Z" fill="currentColor"/>
<path d="M6 16C6 16.5523 5.55228 17 5 17C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15C5.55228 15 6 15.4477 6 16Z" fill="currentColor"/>
<path d="M15 4.35465L12 1.65466L9 4.35468V2H7V6.15468L3 9.75468V7H1V22H23V7H21V9.75465L17 6.15465V2H15V4.35465ZM15 7.04537V20H9V7.0454L12 4.34539L15 7.04537ZM21 20H17V8.84537L21 12.4454V20ZM3 12.4454L7 8.8454V20H3V12.4454Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Milan
};
